import {
    Component,
    OnInit,
    OnDestroy,
    AfterViewInit,
    Inject,
    Input,
    ViewChild
} from '@angular/core';
import { Store, select } from '@ngrx/store';
import { DatePipe } from '@angular/common';
import { LoggingService } from '../../shared/services/logging/logging.service';
import * as fromIJ_r from '../store/reducer';
import * as fromUser from '../../user-info/store/user.reducer';
import * as fromErrors from '../../shared';
import * as fromLookups from '../../lookups';
import { Process } from '../../shared';
import { IIndirectStructure } from '../IIndirectStructure';
import { combineLatest, Observable, ReplaySubject } from 'rxjs';
import { IndirectJobsPresentersComponent } from '../presenters/indirect-jobs-presenters.component';
import { map, takeWhile } from 'rxjs/operators';
import { LoadIndirectJobs, Reset, UpdateIndirectJobs } from '../store/actions';
import { IShowErrors } from '../../shared/errors-sidenav';
import * as fromShared from '../../shared';
import { Account } from '../../account';
import * as fromAccount from '../../account';
import * as fromThirdPartyPayroll from '../../payroll/third-party/store';
import { PayrollCode } from '../../payroll/third-party';

@Component({
    selector: 'ef-indirect-jobs-features',
    templateUrl: './indirect-jobs-features.component.html',
    styleUrls: ['./indirect-jobs-features.component.scss'],
    standalone: false
})
export class IndirectJobsFeaturesComponent
    implements OnInit, OnDestroy, AfterViewInit {
    public active = true;
    process$: Observable<fromShared.Process>;
    public accounts$: Observable<Array<Account>>;
    public jobs$: Observable<Array<IIndirectStructure>>;
    public jobs: Array<IIndirectStructure> = [];
    public indirectTypes$: Observable<fromLookups.IndirectType[]>;
    public indirectTypes: Array<fromLookups.IndirectType> = [];
    public userGroups$: Observable<Array<fromLookups.IUserGroup>>;
    public userGroups: Array<fromLookups.IUserGroup> = [];


    @ViewChild(IndirectJobsPresentersComponent, { static: true })
    ijpc: IndirectJobsPresentersComponent;

    errors$: Observable<string[]>;
    selectedError$: Observable<IShowErrors>;
    ShowError = new ReplaySubject<fromShared.Errors.IShowErrors>(1);
    paycodes$: Observable<PayrollCode[]>;
    constructor(
        private IndirectJobsStore: Store<fromIJ_r.State>,
        @Inject(LoggingService) private log: LoggingService,
        private lookupsStore: Store<fromLookups.LookupState>,
        private store: Store<fromUser.State>,
        private errorStore: Store<fromShared.Errors.State>
    ) {}

    ngOnDestroy() {
        this.active = false;
    }
    ngOnInit() {
        this.store.dispatch(fromThirdPartyPayroll.getPayrollCodes());
        this.store.dispatch(
            fromAccount.getAccounts({ AccountType: '', LaborType: 'labor' })
        );
        this.process$ = this.store.pipe(select(fromShared.selectCurrent));
        this.jobs$ = this.IndirectJobsStore.pipe(
            select(fromIJ_r.getIndirectJobs)
        );
        this.indirectTypes$ = this.lookupsStore.pipe(
            select(fromLookups.getIndirectTypes)
        );
        this.userGroups$ = this.lookupsStore.pipe(
            select(fromLookups.getUserGroupsLookup)
        );

        this.errors$ = this.store.pipe(select(fromIJ_r.getIndirectJobsErrors));

        this.selectedError$ = this.errorStore.pipe(
            select(fromShared.Errors.getShowErrors)
        );
    }
    ngAfterViewInit() {
        this.IndirectJobsStore.dispatch(new LoadIndirectJobs());
        this.store.dispatch(new fromLookups.LoadIndirectTypes());
        this.store.dispatch(new fromLookups.LoadUserGroups());


        combineLatest([this.process$, this.ShowError])
            .pipe(takeWhile(() => this.active))
            .subscribe(([process, event]) => {
                this.store.dispatch(
                    new fromShared.Errors.SetShowErrors({
                        open: event.open,
                        MsgEntityID: event.MsgEntityID,
                        MsgProcessID: process.ProcessID
                    })
                );
            });

        this.jobs$.pipe(takeWhile(_ => this.active)).subscribe(_jobs => {
            this.jobs = _jobs;
        });

        this.paycodes$ = this.store.pipe(
            select(fromThirdPartyPayroll.selectPayrollCodes)
        );

        this.accounts$ = this.store.pipe(select(fromAccount.selectAll));

        this.ijpc.resetFilters
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                this.IndirectJobsStore.dispatch(new LoadIndirectJobs());
            });

        this.ijpc.rowUpdate
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    this.IndirectJobsStore.dispatch(
                        new UpdateIndirectJobs(value)
                    );
                }
            });

        this.ijpc.resetData
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                this.IndirectJobsStore.dispatch(new Reset());
            });
    }

    public onResetData() {
        this.IndirectJobsStore.dispatch(new Reset());
    }

    OnShowError(event) {
        this.ShowError.next(event);
    }

    OnGetAccounts(event) {
        this.store.dispatch(
            fromAccount.getAccounts({ AccountType: event.accountType, LaborType: event.laborType })
        );
    }
}
